import { render, staticRenderFns } from "./ModalCadastrarPlano.vue?vue&type=template&id=1bacd616&scoped=true&"
import script from "./ModalCadastrarPlano.vue?vue&type=script&lang=js&"
export * from "./ModalCadastrarPlano.vue?vue&type=script&lang=js&"
import style0 from "./ModalCadastrarPlano.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacd616",
  null
  
)

export default component.exports